import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch, apiUpload } from "../../api/client";
import { buildAvatarForm } from "../../utils/resizeImage";
import { ME_QUERY_KEY } from "./useMe";

export const useUpdateScout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...fields }) => apiFetch(`/scouts/${id}`, { method: "PATCH", body: fields }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
};

export const useLatestScoutTracking = (scoutId, options = {}) =>
  useQuery({
    queryKey: ["scout-tracking", "latest", scoutId],
    queryFn: () =>
      apiFetch("/scout-tracking", {
        query: { scout_id: scoutId, sort: "record_date", order: "desc", pageSize: 1 },
      }),
    select: (data) => data?.items?.[0] ?? { metrics: {} },
    enabled: Boolean(scoutId) && (options.enabled ?? true),
  });

// Replaces only the top-level sections sent (e.g. { athlete_visibility }).
export const usePatchScoutTrackingDay = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ date, metrics }) =>
      apiFetch(`/scout-tracking/by-date/${date}`, { method: "PATCH", body: { metrics } }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["scout-tracking"] }),
  });
};

// Profile photo -> R2 through the backend (writes both details avatar keys).
export const useUploadScoutAvatar = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, file }) => apiUpload(`/scouts/${id}/avatar`, await buildAvatarForm(file)),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
};
